import { defineMessages } from 'react-intl'

const scope = `procurify.modules.reports.feature-sets.ReportExportHistoryView`

export default defineMessages({
  showingLabel: {
    id: `${scope}.showingLabel`,
    defaultMessage: 'Showing:',
  },
  deleteConfirmationHeader: {
    id: `${scope}.deleteConfirmationHeader`,
    defaultMessage: 'Confirmation',
  },
  deleteConfirmationContent: {
    id: `${scope}.deleteConfirmationContent`,
    defaultMessage: "Are you sure you want to delete this export's record?",
  },
  deleteConfirmationConfirmButtonText: {
    id: `${scope}.deleteConfirmationConfirmButtonText`,
    defaultMessage: 'Confirm',
  },
  deleteConfirmationCancelButtonText: {
    id: `${scope}.deleteConfirmationCancelButtonText`,
    defaultMessage: 'Cancel',
  },
})
